/**
 * Custom Tab Panel UI
 */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Container, Box } from '@mui/material';

/**
 * @param {Number} index
 * @param {string} name
 * @returns Tabs ID and aria-control name
 */
export function a11yProps(index, name) {
  return {
    id: `${name}-tab-${index}`,
    'aria-controls': `${name}-tabpanel-${index}`,
  };
}

/**
 * @param {any} props
 * @returns Double Tab Panel UI
 */
export function DoubleTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`double-tabpanel-${index}`}
      aria-labelledby={`double-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Container sx={{ p: '0', m: '0', maxWidth: '100% !important' }}>{children}</Container>
        </Box>
      )}
    </div>
  );
}

// Double Tab panel input parameter type definition
DoubleTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

/**
 * @param {any} props
 * @returns Thriple Tab Panel UI
 */
export function ThripleTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`thriple-tabpanel-${index}`}
      aria-labelledby={`thriple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Container sx={{ p: '0', m: '0', maxWidth: '100% !important' }}>{children}</Container>
        </Box>
      )}
    </div>
  );
}

// Thriple Tab Panel input parameter type definition
ThripleTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

/**
 * @param {any} props
 * @returns Quadruple Tab Panel UI
 */
export function QuadrupleTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`quadruple-tabpanel-${index}`}
      aria-labelledby={`quadruple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Container sx={{ p: '0', m: '0', maxWidth: '100% !important' }}>{children}</Container>
        </Box>
      )}
    </div>
  );
}

// Quadruple Tab Panel input parameter type definition
QuadrupleTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

/**
 * @param {any} props
 * @returns Quintuple Tab Panel UI
 */
export function QuintupleTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`quintuple-tabpanel-${index}`}
      aria-labelledby={`quintuple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Container sx={{ p: '0', m: '0', maxWidth: '100% !important' }}>{children}</Container>
        </Box>
      )}
    </div>
  );
}

// Quintuple Tab Panel input parameter type definition
QuintupleTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
